import React from 'react'
import './style.css'

class PopupDevice extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showRemovePrompt: false,
      fields: props.fields
    }

    this.togglePrompt = this.togglePrompt.bind(this)
  }

  togglePrompt() {
    this.setState({
      showRemovePrompt: !this.state.showRemovePrompt
    })
  }

  render() {
    const { deviceId,  deviceName } = this.props.device
    const { showRemovePrompt } = this.state

    return (
      <div className="user-device-row">
        <span className="device-name">{deviceName}</span>
        <button
          className={`device-remove ${showRemovePrompt ? 'hide' : ''}`}
          onClick={ this.togglePrompt }>
          <ion className="ion-trash-b"/>
        </button>

        <div className={`device-remove-prompt ${showRemovePrompt ? '' : 'hide'}`}>
          <span className="desktop-prompt">{this.state.fields.manageDevicesDeleteConfirmation}</span>
          <button
            className="device-remove-final"
            onClick={() => this.props.removeDevice(deviceId, deviceName ) }>
            {this.state.fields.cancelYesLabel}
          </button>
          <button onClick={ this.togglePrompt }>{this.state.fields.cancelNoLabel}</button>
        </div>
      </div>
    )
  }
}

export default PopupDevice;